<template>
  <div>
    <navbar :hasSearch="true" />
    <div id="content" class="AruddProcessingLogs">
      <div class="row">
        <div class="col-md-6 pb-3">
          <div class="card h-100">
            <ol class="breadcrumb lighten-4 my-auto">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'landingPage' }">
                  <a class="black-text" href="#">Home</a>
                </router-link>
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
              <li class="breadcrumb-item active font-weight-bold">
                ARUDD Processing Logs
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
            </ol>
          </div>
        </div>
        <quick-links></quick-links>
      </div>

      <div class="content_body">
        <div class="container-fluid no-pad">
          <div id="aruddProcessingLogs">
            <div class="container-fluid no-pad">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="border border-light rounded">
                        <!-- Refine start -->
                        <form @submit.prevent="submit">
                          <div class="col-sm-12 bg-white brs pt-3 pb-2">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <label for="">Log Level</label>
                              </div>
                              <div class="col-auto">
                                <select
                                  class="form-control mb-2"
                                  v-model="level"
                                  aria-placeholder="Filter By Level"
                                >
                                  <option value="All" label="All" />
                                  <option
                                    value="Information"
                                    label="Information"
                                  />
                                  <option value="Problem" label="Problem" />
                                </select>
                              </div>
                            </div>
                            <div class="row dpmw">
                              <div class="col-12 col-sm-7 col-md-6">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <a
                                      @click="last30Days"
                                      role="button"
                                      class="
                                        btn btn-hc-outline btn-block
                                        no-pad
                                      "
                                      >Last 30 days</a
                                    >
                                  </div>
                                  <div class="col-sm-6">
                                    <a
                                      @click="last6Months"
                                      role="button"
                                      class="
                                        btn btn-hc-outline btn-block
                                        no-pad
                                      "
                                      >Last 6 months</a
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-6 mt-2">
                                    <a
                                      @click="last12Months"
                                      role="button"
                                      class="
                                        btn btn-hc-outline btn-block
                                        no-pad
                                      "
                                      >Last 12 months</a
                                    >
                                  </div>
                                  <div class="col-sm-6 mt-2">
                                    <a
                                      @click="resetFilter"
                                      role="button"
                                      class="
                                        btn btn-hc-outline btn-block
                                        no-pad
                                      "
                                      >Reset filters</a
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 col-sm-5 col-md-6">
                                <div class="row">
                                  <div class="col-sm-12">
                                    <el-date-picker
                                      v-model="startDate"
                                      format="dd.MM.yyyy"
                                      type="date"
                                      placeholder="Select a start date"
                                    ></el-date-picker>
                                  </div>
                                  <div class="col-sm-12">
                                    <el-date-picker
                                      class="my-2"
                                      v-model="endDate"
                                      format="dd.MM.yyyy"
                                      type="date"
                                      placeholder="Select an end date"
                                    ></el-date-picker>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <!-- Refine end -->
                      <div
                        class="
                          border border-light
                          rounded
                          bg-white
                          brs
                          mt-3
                          pl-3
                          pr-3
                        "
                      >
                        <div class="row mt-3 mb-3">
                          <div class="col-md-6 col-lg-4">
                            <h4>ARUDD Processing Logs</h4>
                          </div>
                        </div>

                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-lg-12">
                              <AruddProcessingLogsTable
                                class="table-striped"
                                v-if="logsFiltered"
                                :logs="logsFiltered"
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-12">
                            <div>
                              <div class="overflow-auto"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- content close -->
</template>
<script>
import moment from 'moment';
import Navbar from '@/components/Navbar.vue';
import QuickLinks from '@/components/QuickLinks.vue';
import AruddProcessingLogsTable from '@/components/tables/AruddProcessingLogs.vue';

export default {
  name: 'PageAruddProcessingLogs',
  components: {
    Navbar,
    QuickLinks,
    AruddProcessingLogsTable,
  },

  data() {
    return {
      d_startDate: undefined,
      d_endDate: undefined,
      d_level: undefined,

      logs: [],
    };
  },

  computed: {
    defaultStartDate() {
      return moment()
        .subtract(this.$config.honeycomb.signUpLogs.defaultDaysShown, 'days')
        .format('YYYY-MM-DD');
    },

    defaultLevel() {
      return this.$config.honeycomb.signUpLogs.defaultDaysShown;
    },

    startDate: {
      get() {
        return this.d_startDate
          ? moment(this.d_startDate).format('YYYY-MM-DD')
          : this.defaultStartDate;
      },

      set(val) {
        this.d_startDate = val;
      },
    },

    endDate: {
      get() {
        return (
          this.d_endDate &&
          moment(this.d_endDate)
            .add(1, 'days')
            .format('YYYY-MM-DD')
        );
      },
      set(val) {
        this.d_endDate = val;
      },
    },

    level: {
      get() {
        return this.d_level || this.$config.honeycomb.signUpLogs.defaultLevel;
      },
      set(val) {
        this.d_level = val
      },
    },

    logsMapped() {
      if (!this.logs) return;
      return this.logs.map((log) => ({
        ...log,
        _tableClass: this.rowClass(log.Level),
      }));
    },

    logsFilteredByByLevel() {
      if (!this.logsMapped) return;

      if (this.level !== "All")
        return this.logsMapped.filter((s) => s.Level === this.level);
      else return this.logsMapped;
    },

    logsFiltered() {
      if (!this.logsFilteredByByLevel) return;

      let logs = this.logsFilteredByByLevel;

      if (this.startDate)
        logs = logs.filter((s) => this.startDate <= s.LoggedAt);

      if (this.endDate)
        logs = logs.filter((s) => this.endDate >= s.LoggedAt);

      return logs;
    },
  },
  async mounted() {
    this.logs = await this.$store.dispatch('getAruddProcessingLogs');
  },
  methods: {
    last30Days() {
      this.endDate = null;
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 30,
      );
    },
    last6Months() {
      this.endDate = null;
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 180,
      );
    },
    last12Months() {
      this.endDate = null;
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 365,
      );
    },
    resetFilter() {
      this.startDate = null;
      this.endDate = null;
      this.filterBy = 'Problem';
    },

    rowClass(level) {
      if (level === 'Problem') return 'danger';
      if (level === 'Warning') return 'warning';
    },
  },
};
</script>